import createIcon from '../../createIcon';

/**
 * @component @name AttachFile
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTYgNlYxNy41QzE2IDE5LjcxIDE0LjIxIDIxLjUgMTIgMjEuNUM5Ljc5IDIxLjUgOCAxOS43MSA4IDE3LjVWNUM4IDMuNjIgOS4xMiAyLjUgMTAuNSAyLjVDMTEuODggMi41IDEzIDMuNjIgMTMgNVYxNS41QzEzIDE2LjA1IDEyLjU1IDE2LjUgMTIgMTYuNUMxMS40NSAxNi41IDExIDE2LjA1IDExIDE1LjVWNkg5LjVWMTUuNUM5LjUgMTYuODggMTAuNjIgMTggMTIgMThDMTMuMzggMTggMTQuNSAxNi44OCAxNC41IDE1LjVWNUMxNC41IDIuNzkgMTIuNzEgMSAxMC41IDFDOC4yOSAxIDYuNSAyLjc5IDYuNSA1VjE3LjVDNi41IDIwLjU0IDguOTYgMjMgMTIgMjNDMTUuMDQgMjMgMTcuNSAyMC41NCAxNy41IDE3LjVWNkgxNloiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const AttachFile = createIcon('AttachFile', [
  [
    'path',
    {
      d: 'M16 6V17.5C16 19.71 14.21 21.5 12 21.5C9.79 21.5 8 19.71 8 17.5V5C8 3.62 9.12 2.5 10.5 2.5C11.88 2.5 13 3.62 13 5V15.5C13 16.05 12.55 16.5 12 16.5C11.45 16.5 11 16.05 11 15.5V6H9.5V15.5C9.5 16.88 10.62 18 12 18C13.38 18 14.5 16.88 14.5 15.5V5C14.5 2.79 12.71 1 10.5 1C8.29 1 6.5 2.79 6.5 5V17.5C6.5 20.54 8.96 23 12 23C15.04 23 17.5 20.54 17.5 17.5V6H16Z',
      key: '14i5jh',
    },
  ],
]);

export default AttachFile;
